import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/` on the operator artifact is a doorway, not a page. Its target is the
 * organizations list: the console's own home page is gone, now that
 * organization creation is the list's own toolbar action
 * (`CreateOrganizationAction`) and the console's only other surface, usage
 * figures, still has no endpoint.
 *
 * The screens sit at the root, not under a `/backoffice` prefix. This app is
 * its own artifact on its own host, which is what keeps it separable
 * from the client; a path segment repeating that said nothing more.
 *
 * It used to decide instead: read the session, send a platform operator on,
 * and render a dead end to anyone else. That dead end existed to break a
 * redirect loop — `/` forwarding everyone to `/operator` while the area guard
 * sent whoever it refused back to `/` — and the loop only ever formed through
 * the mock. On this artifact a session IS the operator identity, which lives
 * in its own realm and its own tables with no self-service provisioning
 * (OPSSTD-4725), so there was nobody for the guard to refuse: no reachable
 * case for the branch, the page, or the loop they were guarding against.
 *
 * The redirect stays in `beforeLoad` and this route has no component at all.
 * A component would render for one frame before the redirect took effect, and
 * a surface must not show even for a frame.
 */
export const Route = createFileRoute('/(private)/')({
	beforeLoad: () => {
		throw redirect({ to: '/organizations' })
	}
})
